import { render, staticRenderFns } from "./ShareWhatsAppComponent.vue?vue&type=template&id=77c16ee4&scoped=true"
import script from "./ShareWhatsAppComponent.vue?vue&type=script&lang=js"
export * from "./ShareWhatsAppComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c16ee4",
  null
  
)

export default component.exports